var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Center } from "@reverb-ui/react";
import * as jwt from "jsonwebtoken";
import React, { useCallback, useEffect, useState } from "react";
import { Loading } from "../../../components/loading";
import { PopupDisabled } from "../../../components/pop-up-is-disabled";
import { useHistory } from "react-router";
var CACHED_AUTH_TOKEN_KEY = process.env.CACHED_AUTH_TOKEN_KEY;
var ACCOUNT_URL = process.env.APP_BASE_URL;
var initialState = {
    loading: false,
    isLoggedIn: false,
    logOut: function () { return null; },
    loginWithCockpit: function (email) { return Promise.resolve(""); },
    exitCockpit: function () { return null; },
    changePassword: function () { return Promise.resolve(); },
    generateQrCode: function () { return Promise.resolve(""); },
    toggleTfa: function () { return Promise.resolve(); },
    recoverTfaPin: function () { return Promise.resolve(); },
    renewToken: function () { return Promise.resolve(); },
    validateTfaToken: function () { return Promise.resolve(); },
    changeProfile: function () { return Promise.resolve(); },
    getUser: function () { return Promise.resolve({}); },
};
export var AuthContext = React.createContext(initialState);
export var AuthProvider = function (_a) {
    var children = _a.children, authClient = _a.authClient, ssoApi = _a.ssoApi, entityApi = _a.entityApi, cacheStorage = _a.cacheStorage;
    var _b = useState(initialState), authState = _b[0], setAuthState = _b[1];
    var history = useHistory();
    var _c = useState(), isValidated = _c[0], setIsValidated = _c[1];
    useEffect(function () {
        var _a;
        var user = jwt.decode(authState.token);
        var talentWalletId = getTalentWalletByTokenData(user);
        var clientWallets = getEmployeeWalletByTokenData(user);
        setAuthState(function (previousState) {
            var _a;
            return (__assign(__assign({}, previousState), { user: user, talentWalletId: talentWalletId, clientWallets: clientWallets, rockId: (_a = user === null || user === void 0 ? void 0 : user.entity) === null || _a === void 0 ? void 0 : _a.rockId }));
        });
        if (user && (!((_a = user === null || user === void 0 ? void 0 : user.entity) === null || _a === void 0 ? void 0 : _a.rockId) || (authState === null || authState === void 0 ? void 0 : authState.isEntityStandalone))) {
            history.push("/first-access");
        }
    }, [authState.token]);
    var getTalentWalletByTokenData = function (tokenData) {
        var _a;
        if (((_a = tokenData === null || tokenData === void 0 ? void 0 : tokenData.entityManagement) === null || _a === void 0 ? void 0 : _a.type) !== "TALENT") {
            return undefined;
        }
        return tokenData.entityManagement.walletId;
    };
    var getEmployeeWalletByTokenData = function (tokenData) {
        var _a;
        if (((_a = tokenData === null || tokenData === void 0 ? void 0 : tokenData.entityManagement) === null || _a === void 0 ? void 0 : _a.type) !== "EMPLOYEE") {
            return [];
        }
        return [
            {
                walletUuid: tokenData === null || tokenData === void 0 ? void 0 : tokenData.entityManagement.walletId,
                rockId: tokenData === null || tokenData === void 0 ? void 0 : tokenData.entityManagement.clientRockId,
                name: tokenData === null || tokenData === void 0 ? void 0 : tokenData.entityManagement.clientName,
            },
        ];
    };
    var verifyIfAccountIsValidated = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // TODO: fix implementation of validation before uncomment check https://rock-content.atlassian.net/browse/TPL-1726
            // if (authState?.user?.isValidated) {
            //   return true;
            // }
            //
            // const { validated } = await ssoApi.isUserAccountValidated();
            //
            // return validated;
            return [2 /*return*/, true];
        });
    }); };
    var checkIfUserIsEntityStandalone = function (token) { return __awaiter(void 0, void 0, void 0, function () {
        var user, entitiesByUserId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    user = jwt.decode(token);
                    return [4 /*yield*/, entityApi.getEntities({
                            search: user.userId,
                            isStandalone: true,
                            limit: 1,
                        })];
                case 1:
                    entitiesByUserId = _a.sent();
                    return [2 /*return*/, !!entitiesByUserId.length];
            }
        });
    }); };
    useEffect(function () {
        if (!(authState === null || authState === void 0 ? void 0 : authState.user))
            return;
        verifyIfAccountIsValidated().then(setIsValidated);
    }, [authState === null || authState === void 0 ? void 0 : authState.user]);
    var getAuthToken = function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, authClient.getToken()];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    e_1 = _a.sent();
                    return [2 /*return*/, authClient.login()];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getRefreshAuthToken = function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, authClient.getRefreshToken()];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    e_2 = _a.sent();
                    return [2 /*return*/, authClient.login()];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (authState.loading || authState.token || authState.error)
            return;
        setAuthState(function (state) { return (__assign(__assign({}, state), { loading: true, error: undefined })); });
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, token_1, refreshToken_1, tokenData, emailToSimulate_1, isEntityStandalone_1, e_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, Promise.all([
                                getAuthToken(),
                                getRefreshAuthToken(),
                            ])];
                    case 1:
                        _a = _b.sent(), token_1 = _a[0], refreshToken_1 = _a[1];
                        tokenData = jwt.decode(token_1);
                        emailToSimulate_1 = getEmailToSimulateByToken(tokenData);
                        return [4 /*yield*/, checkIfUserIsEntityStandalone(token_1)];
                    case 2:
                        isEntityStandalone_1 = _b.sent();
                        setAuthState(function (state) { return (__assign(__assign({}, state), { token: token_1, refreshToken: refreshToken_1, simulated: !!emailToSimulate_1, loading: false, error: undefined, isLoggedIn: true, simulatedEmail: emailToSimulate_1, isEntityStandalone: isEntityStandalone_1 })); });
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _b.sent();
                        cacheStorage.set(CACHED_AUTH_TOKEN_KEY, null);
                        setAuthState(function (state) { return (__assign(__assign({}, state), { token: undefined, refreshToken: undefined, simulated: false, loading: false, error: e_3, isLoggedIn: false, simulatedEmail: undefined })); });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
    }, [authState.token, authState.refreshToken, authState.loading]);
    var logOut = useCallback(function (onLogOut) {
        authClient.logout().finally(function () {
            cacheStorage.set(CACHED_AUTH_TOKEN_KEY, null);
            setAuthState(function (state) { return (__assign(__assign({}, state), { token: undefined })); });
            onLogOut && onLogOut();
        });
    }, []);
    var getEmailToSimulateByToken = function (tokenData) {
        var _a, _b;
        if (!((_a = tokenData === null || tokenData === void 0 ? void 0 : tokenData.pilot) === null || _a === void 0 ? void 0 : _a.email)) {
            return null;
        }
        return (_b = tokenData === null || tokenData === void 0 ? void 0 : tokenData.userManagement) === null || _b === void 0 ? void 0 : _b.email;
    };
    var loginWithCockpit = useCallback(function (email) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, token_2, refreshToken_2, isEntityStandalone_2, e_4;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    return [4 /*yield*/, authClient.cockpit(email)];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, Promise.all([
                            getAuthToken(),
                            getRefreshAuthToken(),
                        ])];
                case 2:
                    _a = _b.sent(), token_2 = _a[0], refreshToken_2 = _a[1];
                    cacheStorage.set(CACHED_AUTH_TOKEN_KEY, { token: token_2, simulating: email });
                    return [4 /*yield*/, checkIfUserIsEntityStandalone(token_2)];
                case 3:
                    isEntityStandalone_2 = _b.sent();
                    setAuthState(function (state) { return (__assign(__assign({}, state), { token: token_2, refreshToken: refreshToken_2, simulated: true, simulatedEmail: email, isEntityStandalone: isEntityStandalone_2 })); });
                    return [2 /*return*/, token_2];
                case 4:
                    e_4 = _b.sent();
                    setAuthState(function (state) { return (__assign(__assign({}, state), { simulated: false, errorSimulatingAccount: e_4 })); });
                    throw e_4;
                case 5: return [2 /*return*/];
            }
        });
    }); }, []);
    var exitCockpit = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, authClient.cockpitLogout()];
                case 1:
                    _a.sent();
                    cacheStorage.set(CACHED_AUTH_TOKEN_KEY, null);
                    window.location.reload();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var changePassword = useCallback(function (password) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ssoApi.changePassword(password)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var changeProfile = useCallback(function (clientRockId, typeProfile) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, token, refreshToken;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, ssoApi.changeProfile(clientRockId, typeProfile)];
                case 1:
                    _a = _b.sent(), token = _a.token, refreshToken = _a.refreshToken;
                    window.location.href = ACCOUNT_URL + "save-cookie?token=" + token + "&refreshToken=" + refreshToken + "&origin=" + ACCOUNT_URL;
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var generateQrCode = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var qrcode;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ssoApi.generateQrCode()];
                case 1:
                    qrcode = _a.sent();
                    return [2 /*return*/, qrcode];
            }
        });
    }); }, []);
    var toggleTfa = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ssoApi.toggleTfa()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var recoverTfaPin = useCallback(function (email) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ssoApi.removerTfaPin(email)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var validateTfaToken = useCallback(function (token) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ssoApi.validateTfaToken(token)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var renewToken = function () { return __awaiter(void 0, void 0, void 0, function () {
        var token, refreshToken, newToken, isEntityStandalone;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, authClient.getToken()];
                case 1:
                    token = _a.sent();
                    return [4 /*yield*/, authClient.getRefreshToken()];
                case 2:
                    refreshToken = _a.sent();
                    return [4 /*yield*/, ssoApi.refreshToken(token, refreshToken)];
                case 3:
                    newToken = (_a.sent()).token;
                    return [4 /*yield*/, checkIfUserIsEntityStandalone(newToken)];
                case 4:
                    isEntityStandalone = _a.sent();
                    setAuthState(function (state) { return (__assign(__assign({}, state), { token: newToken, isEntityStandalone: isEntityStandalone })); });
                    return [2 /*return*/];
            }
        });
    }); };
    if (authState.error)
        return React.createElement(PopupDisabled, null);
    if (authState.loading || !authState.token || !authState.user)
        return (React.createElement(Center, { h: "100vh", bg: "gray.100" },
            React.createElement(Loading, null)));
    return (React.createElement(AuthContext.Provider, { value: __assign(__assign({}, authState), { logOut: logOut, loginWithCockpit: loginWithCockpit, exitCockpit: exitCockpit, changePassword: changePassword, generateQrCode: generateQrCode, toggleTfa: toggleTfa, recoverTfaPin: recoverTfaPin, validateTfaToken: validateTfaToken, renewToken: renewToken, isValidated: isValidated, changeProfile: changeProfile }) }, children));
};
